import { useEffect, useState } from "react";
import { IUsersDropdown } from "../../models/IDropdown";
import { Fetch } from "../../shared/Fetch";
import { JVDropdown } from "../../shared/JVDropdown";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { ITicketMast } from "../../models/TicketMast";

interface Iat {
    user: number
}

interface Iprops {
    ticket_ID: number,
    department: number,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

const schema = yup.object({
    user: yup.number().required("Select User").min(1, "Select User")
});

export const Assign = (props: Iprops) => {
    const [users, setUsers] = useState<Array<IUsersDropdown>>();
    const [loading, setLoading] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset } = useForm<Iat>({
        resolver: yupResolver(schema),
        defaultValues: { user: 0 },
        shouldFocusError: false
    });

    const loadDepartmentUsers = async () => {
        setLoading(true);
        const response = await Fetch("Dropdown/UsersByDepartment", "GET", null, `department=${props.department}`, props.toast);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            setUsers(data);
        }
        setLoading(false);
    }

    useEffect(() => {
        if (props.department) loadDepartmentUsers();
    }, [props.department]);

    const AssignTicket = async (data: Iat) => {
        setLoading(true);
        const assign_ticket: ITicketMast = {
            ticket_ID: props.ticket_ID,
            assignTo: data.user
        };
        const response = await Fetch("Ticket/assign", "PUT", assign_ticket, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', content: "Ticket Assigned Successfully." });
            onHide();
            props.setReload(!props.reload);
        }
        setLoading(false);
    }

    function onSubmit(data: Iat) {
        AssignTicket(data);
    }

    function onHide() {
        props.hideDialog();
        reset();
    }

    return (
        <Dialog visible={props.open} style={{ width: '350px' }} header={`Ticket ID "${props.ticket_ID}"`} className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdown column={1} label="Users" control={control} name="user" options={users} optionLabel="user_Name" optionValue="login_ID" placeholder="Select User" error={errors.user?.message} />
                <div className="field col-12 md:col-12">
                    <Button loading={loading} label="ASSIGN" type="submit"></Button>
                </div>
            </form>
        </Dialog>
    );
}